export const ContactDetailsWizardGetters = {}
